import { readFile } from "fs/promises";
import "path";
const teamsPath = "src/teams.json";
const prerender = true;
const filePath = "src/_games.json";
const games = JSON.parse(await readFile(filePath, "utf8"));
const goals = (Object.values(games).filter(
  (v, i, l) => (
    // v.secondend
    v.secondend != void 0 || v.patch_status == "finished"
  )
  // &&(new Date(v.secondend).toISOString() < new Date().toISOString())
) ?? Object.values(
  await (await fetch(
    // "https://ugpl-ce55b-default-rtdb.europe-west1.firebasedatabase.app/games.json?orderby=%22season%22&equalto=2023"
    // "https://ugpl-ce55b-default-rtdb.europe-west1.firebasedatabase.app/games.json?orderby=%22season%22&equalto=%222023%22"
    "https://ugpl-ce55b-default-rtdb.europe-west1.firebasedatabase.app/games.json?orderBy=%22secondend%22&endAt=%22" + (/* @__PURE__ */ new Date()).toISOString() + "%22&startAt=%222023-06-25T00:09:08.425Z%22"
  )).json()
)).map((v, i, l) => {
  return {
    id: v.id,
    start: v.firststart ?? v.start,
    test: v.test,
    homeid: v.homeid,
    awayid: v.awayid,
    goals: v.goals,
    patch_homeScore: v.patch_homeScore,
    patch_awayScore: v.patch_awayScore,
    secondend: v.secondend
  };
});
const data = JSON.parse(await readFile(teamsPath, "utf8")) ?? //[params.id] ??
await (await fetch(
  // "https://ugpl-ce55b-default-rtdb.europe-west1.firebasedatabase.app/games.json?orderby=%22season%22&equalto=2023"
  "https://ugpl-ce55b-default-rtdb.europe-west1.firebasedatabase.app/teams.json"
)).json();
async function load({ fetch: fetch2, params }) {
  return { teams: data, goals };
}
export {
  load,
  prerender
};
